export const ONLY_NUMBERS_REG_EXP = /^\d+$/;
export const ONLY_LETTERS_AND_SPACE_REG_EXP = /^[a-zA-Z][a-zA-Z\s]*$/;
export const STARTS_WITH_NUMBERS_REG_EXP = /^\d+\s+/;
export const NON_ZERO_REG_EXP = /^(?!0+$)/;
